import { getEnv } from '../env';

export const handleError = (e) => {
  const config = getEnv();
  if (
    config.ENV_NAME &&
    (config.ENV_NAME.toUpperCase() === 'LOCAL' ||
      config.ENV_NAME.toUpperCase() === 'DEV' ||
      config.ENV_NAME.toUpperCase() === 'QA')
  ) {
    throw e;
  } else {
    console.error(e);
    return (window.location.href = `../../public/error-page.html`);
  }
};
